// extracted by mini-css-extract-plugin
export default {"cls1":"Menu-cls1___22663e9662ed842bf66","cls2":"Menu-cls2___d2ef027d7ae3461f1c3 Menu-cls1___22663e9662ed842bf66"};